import React from 'react';
import type { IconProps } from '../types';

export const OHIFLogo = (props: IconProps) => (
  <img
    src={`${window.location.origin}/escribe-logo.svg`}
    alt="OHIF Logo"
    style={{ width: '170px'}}
    {...props}
  />
);

export default OHIFLogo;
